import SecurityTopic from "./SecurityTopic";

export default SecurityTopic;
